// extracted by mini-css-extract-plugin
module.exports = {"poi":"poi--LyfyL","poiContent":"poiContent--1kL0q"};